<template>
  <div
    style="height: 100vh; width: 100%;"
    class="flex justify-center align-items-center"
  >
    <div class="container-xxl">
      <div class="card my-4" style="height: 650px;">
        <div class="card-body">
          <!-- Logo -->

          <!-- /Logo -->
          <div class="row" style="height: 100%;">
            <div
              class="col-sm-6 flex flex-column align-items-center justify-center"
            >
              <div class="app-brand justify-content-center mb-10">
                <a href="login.php" class="app-brand-link">
                  <div class="" style="width: 7rem;">
                    <img src="../assets/img/logo-icon.svg" alt />
                  </div>
                  <span
                    class="app-brand-text demo menu-text fw-bold"
                    style="width: 21rem;"
                  >
                    <img src="../assets/img/logo-text.svg" alt />
                  </span>
                </a>
              </div>
            </div>
            <div class="col-sm-6 flex flex-col" v-if="currentStep == 0">
              <div class="flex-1">
                <h4 class="mb-4 font-bold"></h4>
                <h5 class="mt-4">
                  {{
                    $t(
                      "wizard.this_guide_will_help_you_choose_default_options_for_your_subscription"
                    )
                  }}
                </h5>
                <h5>
                  {{ $t("wizard.it_will_not_take_more_than_minutes") }}
                </h5>
                <div class="row mt-6">
                  <div class="col-md-12">
                    <label class="form-label" for="">{{
                      $t("settings.default_language")
                    }}</label>
                    <div class="row">
                      <div>
                        <div
                          class="form-check custom-option custom-option-basic"
                        >
                          <label
                            class="form-check-label custom-option-content"
                            for="ar_lang"
                          >
                            <input
                              name="ar_lang"
                              class="form-check-input"
                              type="radio"
                              :value="'ar'"
                              v-model="wizard.language"
                              id="ar_lang"
                              @input="changeLanguage('ar')"
                            />
                            <span class="custom-option-header">
                              <span class="h6 mb-0 d-flex align-items-center"
                                >العربية</span
                              >
                            </span>
                          </label>
                        </div>
                      </div>
                      <div class="mt-2 mt-md-0">
                        <div
                          class="form-check custom-option custom-option-basic"
                        >
                          <label
                            class="form-check-label custom-option-content"
                            for="en_lang"
                          >
                            <input
                              name="en_lang"
                              class="form-check-input"
                              type="radio"
                              :value="'en'"
                              v-model="wizard.language"
                              id="en_lang"
                              @input="changeLanguage('en')"
                            />
                            <span class="custom-option-header">
                              <span class="h6 mb-0 d-flex align-items-center"
                                >English</span
                              >
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-6">
                  <div class="col-md-12">
                    <label class="form-label" for="">{{
                      $t("wizard.color_theme")
                    }}</label>
                    <div class="row">
                      <div>
                        <div
                          class="form-check custom-option custom-option-basic"
                        >
                          <label
                            class="form-check-label custom-option-content"
                            for="day_theme"
                          >
                            <input
                              name="day_theme"
                              class="form-check-input"
                              type="radio"
                              :value="'light'"
                              v-model="wizard.color_theme"
                              id="day_theme"
                              @input="changeTheme('light')"
                            />
                            <span class="custom-option-header">
                              <span class="h6 mb-0 d-flex align-items-center">{{
                                $t("wizard.light")
                              }}</span>
                            </span>
                          </label>
                        </div>
                      </div>
                      <div class="mt-2 mt-md-0">
                        <div
                          class="form-check custom-option custom-option-basic"
                        >
                          <label
                            class="form-check-label custom-option-content"
                            for="night_theme"
                          >
                            <input
                              name="night_theme"
                              class="form-check-input"
                              type="radio"
                              :value="'dark'"
                              v-model="wizard.color_theme"
                              id="night_theme"
                              @input="changeTheme('dark')"
                            />
                            <span class="custom-option-header">
                              <span class="h6 mb-0 d-flex align-items-center">{{
                                $t("wizard.dark")
                              }}</span>
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 d-flex justify-content-between">
                <button class="btn btn-warning btn-prev" @click="skipWizard()">
                  <span class="align-middle d-sm-inline-block d-none">{{
                    $t("control.skip_this_time")
                  }}</span>
                </button>
                <button
                  class="btn btn-primary btn-next"
                  @click.prevent="goStep(1)"
                >
                  <span class="align-middle d-sm-inline-block d-none me-sm-2">{{
                    $t("control.next")
                  }}</span>
                  <i class="ti ti-arrow-left ti-xs"></i>
                </button>
              </div>
            </div>
            <div class="col-sm-6 flex flex-col" v-if="currentStep == 1">
              <div class="flex-1">
                <h4 class="mb-4 font-bold">
                  تعديل كلمة المرور الافتراضية
                </h4>
                <h5>
                  نقوم نحن بضبط كلمة مرور افتراضية ابتدائية لجميع المستخدمين
                  الجدد، لسلامة حسابك وضمان عدم الوصول غير المرغب به يرجى تغيير
                  كلمة المرور الافتراضية إلى كلمة مرور قوية وفريدة.
                </h5>
                <div class="col-sm-12 mt-12">
                  <label class="form-label" for="">{{
                    $t("wizard.new_password")
                  }}</label>
                  <div class="input-group">
                    <input
                      type="password"
                      @input="validate"
                      ref="password_input"
                      v-model="wizard.new_password"
                      class="form-control"
                      autocomplete="new-password"
                      placeholder="********"
                      :class="{ 'is-invalid': errors.password }"
                    />
                    <span
                      @click="
                        $refs.password_input.type =
                          $refs.password_input.type === 'password'
                            ? 'text'
                            : 'password'
                      "
                      ref="password_input_eye"
                      class="input-group-text cursor-pointer"
                      ><i class="ti ti-eye"></i
                    ></span>
                  </div>
                  <div v-if="errors.password" class="invalid-feedback">
                    {{ errors.password }}
                  </div>
                </div>
                <div class="col-sm-12 mt-6">
                  <label class="form-label" for="">{{
                    $t("wizard.new_password_confirmation")
                  }}</label>
                  <div class="input-group">
                    <input
                      type="password"
                      @input="validate"
                      ref="password_input_confirm"
                      autocomplete="new-password"
                      v-model="wizard.new_password_confirmation"
                      class="form-control"
                      placeholder="********"
                      :class="{ 'is-invalid': errors.password_confirmation }"
                    />
                    <span
                      @click="
                        $refs.password_input_confirm.type =
                          $refs.password_input_confirm.type === 'password'
                            ? 'text'
                            : 'password'
                      "
                      ref="password_input_eye"
                      class="input-group-text cursor-pointer"
                      ><i class="ti ti-eye"></i
                    ></span>
                  </div>

                  <div
                    v-if="errors.password_confirmation"
                    class="invalid-feedback"
                  >
                    {{ errors.password_confirmation }}
                  </div>
                </div>
              </div>

              <div class="col-12 d-flex justify-content-between">
                <button
                  class="btn btn-label-secondary btn-prev"
                  @click.prevent="goStep(0)"
                >
                  <i class="ti ti-arrow-right ti-xs me-sm-2"></i>
                  <span class="align-middle d-sm-inline-block d-none">{{
                    $t("control.previous")
                  }}</span>
                </button>
                <button
                  class="btn btn-primary btn-next"
                  @click.prevent="goStep(2)"
                  :disabled="!validated1"
                >
                  <span class="align-middle d-sm-inline-block d-none me-sm-2">{{
                    $t("control.next")
                  }}</span>
                  <i class="ti ti-arrow-left ti-xs"></i>
                </button>
              </div>
            </div>
            <div class="col-sm-6 flex flex-col" v-if="currentStep == 2">
              <div class="flex-1">
                <h4 class="mb-4 font-bold">
                  خصائص عامة
                </h4>
                <h5>
                  يرجى ضبط الخصائص العامة لحسابك لضمان تجربة استخدام أفضل.
                </h5>
                <div class="col-sm-12 mt-12">
                  <label class="form-label" for="">{{
                    $t("settings.network_name")
                  }}</label>
                  <input
                    type="text"
                    @input="validate"
                    v-model="wizard.network_name"
                    class="form-control"
                    :class="{ 'is-invalid': errors.network_name }"
                  />
                  <div v-if="errors.network_name" class="invalid-feedback">
                    {{ errors.network_name }}
                  </div>
                </div>
                <div class="col-sm-12 mt-6">
                  <label class="form-label" for="currency">{{
                    $t("settings.currency")
                  }}</label>
                  <div class="input-group">
                    <div class="input-group-text">
                      <i class="ti ti-currency-dollar"></i>
                    </div>
                    <select
                      v-model="wizard.currency"
                      id="currency"
                      class="form-select"
                    >
                      <option
                        v-for="currency in [
                          { name: $t('currencies.usd'), id: '$' },
                          { name: $t('currencies.tr'), id: '₺' },
                          { name: $t('currencies.syp'), id: 'SYP' },
                        ]"
                        v-bind:key="currency.id"
                        :value="currency.id"
                      >
                        {{ currency.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-12 mt-6">
                  <label class="form-label" for="accountResetTime">{{
                    $t("settings.default_expiration_hour")
                  }}</label>
                  <div class="input-group">
                    <div class="input-group-text">
                      <i class="ti ti-clock"></i>
                    </div>
                    <select
                      v-model="wizard.default_expiration_hour"
                      id="accountResetTime"
                      class="form-select"
                    >
                      <option
                        v-for="unit in [
                          { name: '00:00', id: '0' },
                          { name: '01:00', id: '1' },
                          { name: '02:00', id: '2' },
                          { name: '03:00', id: '3' },
                          { name: '04:00', id: '4' },
                          { name: '05:00', id: '5' },
                          { name: '06:00', id: '6' },
                          { name: '07:00', id: '7' },
                          { name: '08:00', id: '8' },
                          { name: '09:00', id: '9' },
                          { name: '10:00', id: '10' },
                          { name: '11:00', id: '11' },
                          { name: '12:00', id: '12' },
                          { name: '13:00', id: '13' },
                          { name: '14:00', id: '14' },
                          { name: '15:00', id: '15' },
                          { name: '16:00', id: '16' },
                          { name: '17:00', id: '17' },
                          { name: '18:00', id: '18' },
                          { name: '19:00', id: '19' },
                          { name: '20:00', id: '20' },
                          { name: '21:00', id: '21' },
                          { name: '22:00', id: '22' },
                          { name: '23:00', id: '23' },
                          { name: $t('control.none'), id: '-1' },
                        ]"
                        v-bind:key="unit.id"
                        :value="unit.id"
                      >
                        {{ unit.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-12 d-flex justify-content-between">
                <button
                  class="btn btn-label-secondary btn-prev"
                  @click.prevent="goStep(1)"
                >
                  <i class="ti ti-arrow-right ti-xs me-sm-2"></i>
                  <span class="align-middle d-sm-inline-block d-none">{{
                    $t("control.previous")
                  }}</span>
                </button>
                <button
                  class="btn btn-primary btn-next"
                  :disabled="!validated2"
                  @click.prevent="goStep(3)"
                >
                  <span class="align-middle d-sm-inline-block d-none me-sm-2">{{
                    $t("control.next")
                  }}</span>
                  <i class="ti ti-arrow-left ti-xs"></i>
                </button>
              </div>
            </div>
            <div class="col-sm-6 flex flex-col" v-if="currentStep == 3">
              <div class="flex-1">
                <h4 class="mb-4 font-bold">
                  تعديل شعار الشبكة
                </h4>
                <h5>
                  يمكنك رفع شعار الشبكة ليتم استخدامه في المطبوعات وضمن الموقع
                </h5>
                <div class="col-sm-12 mt-12">
                  <div
                    class="d-flex flex-col align-items-center justify-content-center align-items-sm-center gap-6"
                  >
                    <img
                      v-if="currentImageUrl"
                      :src="currentImageUrl"
                      alt="user-avatar"
                      class="d-block h-px-100 company-logo-dark"
                      id="uploadedAvatar"
                    />
                    <img
                      v-else
                      src="@/assets/img/company-logo-light.svg"
                      alt="user-avatar"
                      class="d-block h-px-100 company-logo-light"
                      id="uploadedAvatar"
                    />
                    <div class="button-wrapper">
                      <label
                        for="upload"
                        class="btn btn-primary me-3 mb-4"
                        tabindex="0"
                      >
                        <span class="d-none d-sm-block">{{
                          $t("settings.upload_new_logo")
                        }}</span>
                        <i class="ti ti-upload d-block d-sm-none"></i>
                        <input
                          type="file"
                          id="upload"
                          ref="imageFile"
                          @change="selectImage"
                          class="account-file-input"
                          hidden
                          accept="image/png, image/jpeg"
                        />
                      </label>
                      <div>{{ $t("settings.allowed_jpg_svg_png") }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 d-flex justify-content-between">
                <button
                  class="btn btn-label-secondary btn-prev"
                  @click.prevent="goStep(2)"
                >
                  <i class="ti ti-arrow-right ti-xs me-sm-2"></i>
                  <span class="align-middle d-sm-inline-block d-none">{{
                    $t("control.previous")
                  }}</span>
                </button>
                <button
                  class="btn btn-primary btn-next"
                  @click.prevent="goStep(4)"
                >
                  <span
                    class="align-middle d-sm-inline-block d-none me-sm-2"
                    v-if="!wizard.network_logo"
                    >{{ $t("control.skip") }}</span
                  >
                  <span
                    class="align-middle d-sm-inline-block d-none me-sm-2"
                    v-else
                    >{{ $t("control.next") }}</span
                  >
                  <i class="ti ti-arrow-left ti-xs"></i>
                </button>
              </div>
            </div>
            <div class="col-sm-6 flex flex-col" v-if="currentStep == 4">
              <div class="flex-1">
                <h4 class="mb-4 font-bold">
                  تم الضبط بنجاح
                </h4>
                <h5>
                  شكراً لإختيارك Super Speed Radius نتمنى لك تجربة سعيدة.
                </h5>
                <div
                  class="col-sm-12 mt-12 flex justify-center align-items-center"
                >
                  <img src="@/assets/check.png" class="h-64 w-64" alt="" />
                </div>
              </div>

              <div class="col-12 d-flex justify-content-between">
                <button
                  class="btn btn-label-secondary btn-prev"
                  @click.prevent="goStep(3)"
                >
                  <i class="ti ti-arrow-right ti-xs me-sm-2"></i>
                  <span class="align-middle d-sm-inline-block d-none">{{
                    $t("control.previous")
                  }}</span>
                </button>
                <div class="d-flex gap-x-2">
                  <button class="btn btn-warning" disabled>
                    <span
                      class="align-middle d-sm-inline-block d-none me-sm-2"
                      >{{ $t("control.view_tour") }}</span
                    >
                    <i class="ti ti-license ti-xs"></i>
                  </button>
                  <button
                    @click.prevent="store"
                    :disabled="loading || !validated"
                    class="btn btn-success"
                  >
                    <span
                      class="align-middle d-sm-inline-block d-none me-sm-2"
                      >{{ $t("control.ok") }}</span
                    >
                    <i class="ti ti-check ti-xs"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <LoadingElement v-if="loading" />
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
import store from "../store/index.js";

export default {
  name: "Wizard",
  computed: {
    ...mapGetters(["settings"]),
  },
  data() {
    return {
      currentStep: 0,
      validated: false,
      validated1: false,
      validated2: false,
      loading: false,
      wizard: {
        new_password: "",
        new_password_confirmation: "",
        network_name: "SSRadius Network",
        currency: "SYP",
        default_expiration_hour: "12",
        color_theme: "dark",
        language: "ar",
        network_logo: null,
      },
      server_url: localStorage.getItem("server"),
      errors: {
        password: null,
        password_confirmation: null,
        network_name: this.$t("wizard.please_change_network_name"),
      },
      currentImageUrl: null,
    };
  },
  created() {
    if (localStorage.getItem("lang") != null) {
      this.wizard.language = localStorage.getItem("lang");
    }
    if (
      localStorage.getItem(
        "templateCustomizer-vertical-menu-template--Style"
      ) != null
    ) {
      this.wizard.color_theme = localStorage.getItem(
        "templateCustomizer-vertical-menu-template--Style"
      );
    }
    if (
      this.settings.first_time_login == 0 ||
      this.settings.first_time_login == "0"
    ) {
      this.$router.push("/");
    }
  },
  methods: {
    async store() {
      this.loading = true;
      try {
        const data = new FormData();
        if (this.wizard.network_logo)
          data.append("network_logo", this.wizard.network_logo);
        data.append("network_name", this.wizard.network_name);
        data.append("language", this.wizard.language);
        data.append("currency", this.wizard.currency);
        data.append("new_password", this.wizard.new_password);
        data.append(
          "default_expiration_hour",
          this.wizard.default_expiration_hour
        );
        const response = await axios.post("setup/wizard", data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (response.status == 200) {
          this.loading = false;
          this.settings.first_time_login = 0;
          store.dispatch("fetch_user");
          this.$router.push("/");
          this.$swal({
            title: this.$t("wizard.setup_wizard_completed"),
            text: this.$t("wizard.welcome_to_super_speed_radius"),
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
            backdrop: true,
          });
        }
      } catch (error) {
        this.$swal({
          title: this.$t("control.error"),
          text:
            error.response?.data?.message ||
            this.$t("control.some_thing_went_wrong_please_try_again"),
          icon: "error",
          confirmButtonText: this.$t("control.ok"),
          backdrop: true,
        });
      }
      this.loading = false;
    },
    skipWizard() {
      this.settings.first_time_login = 0;
      this.$router.push("/");
    },
    goStep(num) {
      this.currentStep = num;
    },
    changeLanguage(lang) {
      if (lang == "en") {
        window.templateCustomizer.setLang("en");
        window.templateCustomizer.setRtl(false);
        localStorage.setItem("lang", "en");
      } else if (lang == "tr") {
        window.templateCustomizer.setLang("tr");
        window.templateCustomizer.setRtl(false);
        localStorage.setItem("lang", "tr");
      } else if (lang == "ar") {
        window.templateCustomizer.setLang("ar");
        window.templateCustomizer.setRtl(true);
        localStorage.setItem("lang", "ar");
      }
    },
    changeTheme(theme) {
      window.templateCustomizer.setStyle(theme);
    },
    selectImage() {
      this.wizard.network_logo = this.$refs.imageFile.files.item(0);
      this.currentImageUrl = URL.createObjectURL(this.wizard.network_logo);
    },
    validate() {
      this.validated = true;
      this.errors.password = null;
      this.errors.password_confirmation = null;
      this.errors.network_name = null;
      this.validated1 = true;
      this.validated2 = true;
      if (this.wizard.new_password.length <= 6) {
        this.errors.password = this.$t("wizard.weak_password");
        this.validated = false;
        this.validated1 = false;
      }
      if (this.wizard.new_password !== this.wizard.new_password_confirmation) {
        this.errors.password_confirmation = this.$t(
          "wizard.passwords_not_match"
        );
        this.validated = false;
        this.validated1 = false;
      }
      if (this.wizard.new_password == "ssradius1234") {
        this.errors.password = this.$t("wizard.weak_password");
        this.validated = false;
        this.validated1 = false;
      }
      if (
        this.wizard.network_name == "SSRadius Network" ||
        this.wizard.network_name == ""
      ) {
        this.errors.network_name = this.$t("wizard.please_change_network_name");
        this.validated = false;
        this.validated2 = false;
      }
    },
  },
};
</script>
